<span
  class="restricted-indicator"
  [matTooltip]="tooltip"
  matTooltipPosition="below"
>
  <span class="restricted-indicator__glyph">§</span>
</span>
